class DigitalStoreError extends Error {
  constructor ({ code, statusCode, message, error = {} }) {
    super(message)
    this.code = code || error.code
    this.statusCode = statusCode
    this.message = message || error.message
  }
}

export default DigitalStoreError



// WEBPACK FOOTER //
// ../src/error/DigitalStoreError.js